import axios from 'axios';
import log from 'loglevel';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/'
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  log.debug('Starting Request', config);
  return config;
}, error => {
  log.error('Request Error', error);
  return Promise.reject(error);
});

api.interceptors.response.use(response => {
  log.debug('Response:', response);
  return response;
}, error => {
  log.error('Response Error', error);
  return Promise.reject(error);
});

export default api;
